import Common from '../../../Common';

const Member = class extends Common {
	async browse(userId?: number | string) {
		if(userId) {
			return this.get(`/user/${userId}/queue/members`);
		} else {
			return this.get(`/user/queue/members`);
		}
	}

	async create(userId: id, queueId: id) {
		return this.post(`/user/${userId}/queue/${queueId}/member`)
	}

	async update(queueId: id, queueMemberId: id, data: Partial<QueueMember>) {
		return this.patch(`/queue/${queueId}/member/${queueMemberId}`, data)
	}

	delete(queueId: id, queueMemberId: id) {
		return super.doDelete(`/queue/${queueId}/member/${queueMemberId}`)
	}
}

export default Member
